import styled from 'styled-components';
import {
  Text12ExtraBold,
  Text14Regular,
  Text16ExtraBold,
  Text24Bold,
} from '../../../components/utils/Text/Text.styles';

export const PageContainer = styled.div`
  max-height: 100dvh;
  height: 100%;
  display: flex;

  @media only screen and (max-width: 768px) {
    max-height: calc(100dvh - 5.6rem);
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Title = styled(Text24Bold)`
  letter-spacing: -0.408px;
`;

export const Navigator = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2.4rem 0;
  min-width: 38rem;
  max-width: 38rem;
  border-right: 1px solid #f3f4f6;
  background-color: #fff;
  position: relative;

  @media screen and (max-width: 768px) {
    min-width: unset;
    max-width: unset;
    width: 100%;
    border-right: none;
  }
`;

export const NavigatorContent = styled.ul`
  display: flex;
  flex-direction: column;
  list-style-type: none;
`;

export const Content = styled.div`
  overflow: scroll;
  width: 100%;
`;

export const HeaderFilter = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1.6rem;
  overflow: auto;
`;

export const HeaderSearch = styled.div`
  display: flex;
  align-items: flex-end;
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  height: 6rem;
  position: relative;

  svg {
    cursor: pointer;
  }
`;

export const FilterButton = styled.div`
  border-radius: 10px;
  background: #badaf7;
  color: ${({ $selected }) => ($selected ? '#000' : '#3e9be4')};
  font-size: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.15px;
  padding: 1rem 1.4rem;
  min-width: fit-content;
  cursor: pointer;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 5.6rem);
`;

export const ChatsContainer = styled.div`
  overflow: auto;
  height: calc(100% - 5.6rem);
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const ChatItem = styled.div`
  display: flex;
  padding: 1.2rem 1.6rem;
  justify-content: space-between;
  border-bottom: 1px solid #f3f4f6;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#EEF5FD' : 'transparent')};
`;

export const LeftContent = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;

export const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const Dot = styled.div`
  background-color: #1672ba;
  width: 7px;
  min-width: 7px;
  height: 7px;
  border-radius: 50%;
`;

export const SentAtText = styled(Text14Regular)`
  color: ${({ $isSeen }) => !$isSeen && '#1672ba'};
  opacity: ${({ $isSeen }) => $isSeen && '0.3'};
  width: max-content;
`;

export const NumOfMessages = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: -0.11px;
  background-color: #1672ba;
`;

export const Avatar = styled.div`
  border-radius: 1000px;
  border: 1px solid ${({ $newPurchase }) => ($newPurchase ? '#85BB65' : '#fff')};
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 3.2rem;
  height: 3.2rem;
  color: #092f4d;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.12px;
  position: relative;
`;

export const DollarText = styled(Text12ExtraBold)`
  color: #85bb65;
  z-index: 100;
  position: absolute;
  right: 0;
  top: -0.1rem;
  line-height: 1.2rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const ChatTitle = styled(Text16ExtraBold)`
  font-weight: ${({ $isSeen }) => $isSeen && '400'};
  opacity: ${({ $isSeen }) => $isSeen && '0.68'};
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const MessageText = styled(Text14Regular)`
  opacity: ${({ $isSeen }) => $isSeen && '0.68'};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const InfiniteScrollMarker = styled.div`
  height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NewMessageButton = styled.button`
  border-radius: 12px;
  border: 1px solid #61ade9;
  background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
  height: 3.2rem;
  width: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    path {
      stroke: #fff;
    }
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-inline: 1.6rem;
`;

export const NewMessagesContainer = styled.div`
  position: absolute;
  bottom: 1.6rem;
  right: 1.6rem;
  background-color: #badaf7;
  height: 4.6rem;
  width: 4.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
`;

export const EmptyStateContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.8rem;

  button {
    width: unset;
  }
`;
